import { render, staticRenderFns } from "./LocalStorageWatcher.vue?vue&type=template&id=774dd605&"
import script from "./LocalStorageWatcher.vue?vue&type=script&lang=js&"
export * from "./LocalStorageWatcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports